import { AccountDashboardComponent } from './dashboards/pages/account/account.component';
import { AdminDashboardComponent } from './dashboards/pages/admin/admin.component';
import { ObservationsIndexComponent } from './observations/pages/observations/index/index.component';
import { ObservationsCreateComponent } from './observations/pages/observations/create/create.component';
import { ObservationsEditComponent } from './observations/pages/observations/edit/edit.component';
import { CategoriesIndexComponent } from './observations/pages/categories/index/index.component';
import { CategoriesEditComponent } from './observations/pages/categories/edit/edit.component';
import { CategoriesCreateComponent } from './observations/pages/categories/create/create.component';
import { KpiSetsIndexComponent } from './kpis/pages/kpi-sets/index/index.component';
import { KpiSetsCreateComponent } from './kpis/pages/kpi-sets/create/create.component';
import { KpiSetsEditComponent } from './kpis/pages/kpi-sets/edit/edit.component';
import { WorkLogsCreateComponent } from './work-logs/pages/work-logs/create/create.component';
import { WorkLogsIndexComponent } from './work-logs/pages/work-logs/index/index.component';
import { WorkLogsEditComponent } from './work-logs/pages/work-logs/edit/edit.component';
import { DashboardComponent } from './dashboards/pages/dashboard/dashboard.component';
import { SecurityGuardComponent } from './dashboards/pages/security-guard/security-guard.component';

export const Pages = [
    DashboardComponent,
    AccountDashboardComponent,
    SecurityGuardComponent,
    AdminDashboardComponent,
    ObservationsIndexComponent,
    ObservationsEditComponent,
    ObservationsCreateComponent,
    CategoriesIndexComponent,
    CategoriesCreateComponent,
    CategoriesEditComponent,
    KpiSetsIndexComponent,
    KpiSetsCreateComponent,
    KpiSetsEditComponent,
    WorkLogsCreateComponent,
    WorkLogsIndexComponent,
    WorkLogsEditComponent,
];




// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/pages.ts